<mat-selection-list [multiple]="false">
    <mat-list-option [style]="style()" *ngFor="let user of users" [value]="user" (click)="select(user)">
        <app-user-list-row (remove)="removeUser($event)" [user]="user" [mode]="mode" [actions]="actions"></app-user-list-row>
    </mat-list-option>
</mat-selection-list>
